const PLATFORM_KEYS = {
  "x-v2": "x",
  "discord-v2": "discord",
  "telegram-v2": "telegram",
  steam: "steam",
} as const;

type LinkedPlatform = (typeof PLATFORM_KEYS)[keyof typeof PLATFORM_KEYS];

export interface LinkedAccount {
  platform: LinkedPlatform;
  external_id: string;
  created_at: string;
  updated_at: string;
  username: string;
}
